<script>

export default {
  name: 'CoveoSearchBox',
  props: {
    suggestionsLabel: {
      type: String,
      required: true,
    },
  },
  mounted() {
    this.$refs.interface.addEventListener(Coveo.InitializationEvents.afterComponentsInitialization, () => {
      const listbox = this.$el.querySelector('[role="listbox"]');
      const combobox = this.$el.querySelector('[role="combobox"]');

      combobox.setAttribute('aria-label', this.suggestionsLabel);
      listbox.setAttribute('aria-label', this.suggestionsLabel);
      combobox.setAttribute('aria-controls', listbox.id);
    });
  },
};
</script>
